import Social from "./social.js";
export default Social;